import { FontWeight, Heading, LiliButton, Text, UserMessage } from '@lili/lili-frontend-common';
import React from 'react';
import { ReactComponent as TeamFullIcon } from '../../../assets/icons/svg/colored-icons/ic-colored-team.svg';

interface TeamFullModalProps {
  onClick: () => void;
}

export const TeamFullModal = ({ onClick }: TeamFullModalProps) => (
  <UserMessage id='team-full-modal' onClick={onClick}>
    <div className='flex flex-col bg-surface-primary-bw-00 py-[40px] px-[32px] items-center rounded-xl fadeIn'>
      <TeamFullIcon />
      <Heading.H6 fontWeight={FontWeight.MEDIUM} className='text-text-main-primary mt-[24px]'>
        It looks like your team is full
      </Heading.H6>
      <Text.H10 className='text-text-main-primary mt-[8px] mb-[48px]'>
        You can have up to 3 team members and 1 accountant
      </Text.H10>

      <LiliButton id='got-it-button' onClick={onClick} title='Got it' />
    </div>
  </UserMessage>
);
